import { Layout, Dropdown, Space, Image, Typography, Flex, Button } from "antd";
import styled from "styled-components";
import { ReactComponent as ThreeDotsVertical } from "../../../../../../assets/icons/ThreeDotsVertical.svg";
import NoImageSmall from "../../../../../../assets/images/NoImageSmall.svg";

const { Text } = Typography;

export const ExercisesLayout = styled(Layout)`
  margin: 0rem 0;
  background-color: transparent;
`;

export const StyledThreeDotsVertical = styled(ThreeDotsVertical)`
  cursor: pointer;
`;

export const StyledExerciseNameCell = styled(Space).attrs({
  direction: "horizontal",
  size: "middle",
})`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .ant-space-item {
    font-size: 14px;
    font-weight: 400;
    color: #313131;
  }
`;

export const ExerciseImage = styled(Image).attrs({
  height: "2.75rem",
  width: "7.25rem",
  fallback: NoImageSmall,
  preview: false,
})`
  padding: 0;
  margin: 0;
  border: none !important;
  outline: none;
  background: #f1f1f1;
  // gap: 0px;
  opacity: 0.72;
  border-radius: 4px 4px 4px 4px;

  /* Remove border or outline from the image itself */
  .ant-image-img {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none;
  }

  /* If using the image preview, remove its border too */
  .ant-image-mask,
  .ant-image-preview {
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

export const ExerciseNameWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})`
  display: flex;
  align-items: flex-start;
`;

export const ExerciseName = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const ExerciseDescription = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: #808080;
`;

export const StyledVerticalSpace = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})``;

export const StyledHorizontalSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "large",
})`
  display: flex;
  width: 100%;

  .ant-space-item {
    width: 100%;
  }
`;

export const StyledDifficultySpace = styled(Flex)`
  width: 100%;
  display: flex;
  gap: 1rem;

  .ant-space-item:nth-child(1) {
    flex: 2 1 0;
  }

  .ant-space-item:nth-child(2) {
    min-width: 6rem;
    flex: 1 1 0;
  }

  .ant-space-item:nth-child(3) {
    flex: 3 1 0;
  }
`;

export const StyledEquipmentSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "large",
})`
  width: 100%;
  display: flex;

  .ant-space-item:nth-child(1) {
    flex: 1 1 0;
  }

  .ant-space-item:nth-child(2) {
    flex: 2.5 1 0;
  }
`;

export const StyledExerciseCard = styled(Flex)`
  width: 100%;
  height: 55px;
  display: flex;
  flex-direction: row;
  gap: 15px;
  padding: 8px 8px 8px 8px;
  border-radius: 10px 10px 10px 10px;
  position: relative;
  border: 1px solid #f1f1f1;
`;

export const StyledExerciseCardContainer = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  width: 100%;
  padding-bottom: 30px;
`;

export const StyledExerciseCardImage = styled(Image).attrs({
  preview: false,
  height: "2.563rem",
  width: "6.438rem",
})``;

export const StyledExerciseCardLabel = styled(Text)`
  font-size: 14px;
  height: 100%;
  display: flex;
  align-items: center;
`;
